import { Trash2 } from 'lucide-react';
import React, { useState } from 'react';

const InlineDepartmentRow = ({ department, onRemove, onTogglePrimary, onNavigateToEdit }) => {
  const [isUpdating, setIsUpdating] = useState(false);
  
  const handlePrimaryToggle = async (checked) => {
    setIsUpdating(true);
    try {
      await onTogglePrimary(department.id, checked);
    } catch (error) {
      console.error('Failed to toggle primary status:', error);
    } finally {
      setIsUpdating(false);
    }
  };
  
  return (
    <div className="border border-gray-200 rounded bg-white px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <button
            onClick={() => onNavigateToEdit(department.id)}
            className="font-medium text-gray-900 text-sm hover:text-blue-600 hover:underline text-left"
          >
            {department.department_name}
          </button>
          <div className="flex items-center gap-2 text-xs text-gray-500 mt-1">
            <span className={`px-2 py-0.5 rounded text-xs ${
              department.relationship_type === 'primary' 
                ? 'bg-blue-100 text-blue-800' 
                : 'bg-gray-100 text-gray-600'
            }`}>
              {department.relationship_type === 'primary' ? 'Primary' : 'Secondary'}
            </span>
          </div>
        </div>
        
        <div className="flex items-center gap-3">
          {/* Primary Toggle */}
          <div className="flex items-center gap-2">
            <label className="text-xs text-gray-600">Primary</label>
            <label className="relative inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={department.relationship_type === 'primary'}
                onChange={(e) => handlePrimaryToggle(e.target.checked)}
                disabled={isUpdating}
                className="sr-only peer"
              />
              <div className="w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[1px] after:left-[1px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-3 after:w-3 after:transition-all peer-checked:bg-blue-600 disabled:opacity-50"></div>
            </label>
          </div>
          
          {/* Delete Button */}
          <button
            onClick={onRemove}
            className="text-red-500 hover:text-red-700 p-1"
            title="Remove from location"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InlineDepartmentRow;